import React from 'react';

// 32×36 coloured rectangle showing the file extension.
// Colour mapping matches the design tokens (PDF red, DOCX blue, etc.).

type Ext = 'PDF' | 'DOCX' | 'XLSX' | 'PPTX' | 'OTHER';

const KNOWN: Ext[] = ['PDF', 'DOCX', 'XLSX', 'PPTX'];

const extOf = (filename: string): Ext => {
  const idx = filename.lastIndexOf('.');
  if (idx < 0) return 'OTHER';
  const raw = filename.slice(idx + 1).toUpperCase();
  return (KNOWN.includes(raw as Ext) ? raw : 'OTHER') as Ext;
};

interface Props {
  filename: string;
}

const FileIcon = ({ filename }: Props) => {
  const ext = extOf(filename);
  return (
    <div className="fileico" data-t={ext}>
      {ext === 'OTHER' ? '···' : ext}
    </div>
  );
};

export default FileIcon;
